import React from "react"
import PropTypes from "prop-types"
import TpUiPieChart from "./tp-ui-pie-chart"
import TpUiStackedBarChart from "./tp-ui-stacked-bar-chart"
import TpUiDonutChart from "./tp-ui-donut-chart"
import TpUiParallelBarChart from "./tp-ui-parallel-bar-chart"
import TpUiStackedVerlaufBarChart from "./tp-ui-stacked-verlauf-bar-chart"
import {
    convertToDonutChart,
    convertToPieOrParallelBarChart,
    convertToStackedBarChart,
    convertToVerlaufStackedBarChart,
} from "./tp-ui-chart-converter"

export const ChartType = Object.freeze({
    PIE: "PIE",
    BAR: "BAR",
    DONUT: "DONUT",
    ParallelBar: "PARALLEL",
    VERLAUF_BAR: "VERLAUF_BAR",
})

const getData = (data, chartType) => {
    const map = {
        [ChartType.PIE]: () => convertToPieOrParallelBarChart(data),
        [ChartType.BAR]: () => convertToStackedBarChart(data),
        [ChartType.VERLAUF_BAR]: () => convertToVerlaufStackedBarChart(data),
        [ChartType.ParallelBar]: () => convertToPieOrParallelBarChart(data),
        [ChartType.DONUT]: () => convertToDonutChart(data),
    }
    return map[chartType]?.() ?? null
}

const ChartSwitcher = ({data, chartType}) => {
    const chartData = getData(data, chartType)
    return (
        chartData && (
            <>
                {chartType === ChartType.PIE && (
                    <TpUiPieChart data={chartData} />
                )}
                {chartType === ChartType.BAR && (
                    <TpUiStackedBarChart data={chartData} />
                )}
                {chartType === ChartType.DONUT && (
                    <TpUiDonutChart data={chartData} />
                )}
                {chartType === ChartType.ParallelBar && (
                    <TpUiParallelBarChart data={chartData} />
                )}
                {chartType === ChartType.VERLAUF_BAR && (
                    <TpUiStackedVerlaufBarChart data={chartData} />
                )}
            </>
        )
    )
}

ChartSwitcher.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.exact({
            label: PropTypes.string,
            value: PropTypes.number,
            backgroundColor: PropTypes.string,
        }),
    ).isRequired,
    chartType: PropTypes.string.isRequired,
}

export default ChartSwitcher
